import { render, staticRenderFns } from "./TimespanPage.vue?vue&type=template&id=8bc37222&"
import script from "./TimespanPage.vue?vue&type=script&lang=js&"
export * from "./TimespanPage.vue?vue&type=script&lang=js&"
import style0 from "./TimespanPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports